export const GET_ALL_INVOICES = 'billing/getAllInvoices';
export const GET_ALL_INVOICES_START = 'billing/getAllInvoicesStart';
export const GET_ALL_INVOICES_COMPLETE = 'billing/getAllInvoicesCompleted';
export const GET_ALL_INVOICES_ERROR = 'billing/getAllInvoicesError';
export const DOWNLOAD_REPORT = 'billing/downloadReport';
export const DOWNLOAD_REPORT_START = 'billing/downloadReportStart';
export const DOWNLOAD_REPORT_COMPLETE = 'billing/downloadReportCompleted';
export const DOWNLOAD_REPORT_ERROR = 'billing/downloadReportError';
export const DOWNLOAD_INVOICE = 'billing/downloadInvoice';
export const DOWNLOAD_INVOICE_START = 'billing/downloadInvoiceStart';
export const DOWNLOAD_INVOICE_COMPLETE = 'billing/downloadInvoiceCompleted';
export const DOWNLOAD_INVOICE_ERROR = 'billing/downloadInvoiceError';
export const MAKE_MONTHLY_PAYMENT = 'billing/makeMonthlyPayment';
export const MAKE_MONTHLY_PAYMENT_START = 'billing/makeMonthlyPaymentStart';
export const MAKE_MONTHLY_PAYMENT_COMPLETE = 'billing/makeMonthlyPaymentCompleted';
export const MAKE_MONTHLY_PAYMENT_ERROR = 'billing/makeMonthlyPaymentError';
export const CLEAR_ALL_INVOICES_ERROR = 'billing/clearAllInvoicesError';
export const CLEAR_STRIPE_REDIRECT_URL = 'billing/clearStripeRedirectUrl';
export const FETCH_ALL_PAYMENT_TRANSACTIONS = 'billing/fetachAllPaymentTransactions';
export const FETCH_ALL_PAYMENT_TRANSACTIONS_START =
  'billing/fetachAllPaymentTransactionstart';
export const FETCH_ALL_PAYMENT_TRANSACTIONS_COMPLETE =
  'billing/fetachAllPaymentTransactionsCompleted';
export const FETCH_ALL_PAYMENT_TRANSACTIONS_ERROR =
  'billing/fetachAllPaymentTransactionsError';
export const ADD_FUNDS_TO_BANK = 'billing/addFundsToBank';
export const ADD_FUNDS_TO_BANK_START = 'billing/addFundsToBankstart';
export const ADD_FUNDS_TO_BANK_COMPLETE = 'billing/addFundsToBankCompleted';
export const ADD_FUNDS_TO_BANK_ERROR = 'billing/addFundsToBankError';
export const CLEAR_ALL_TRANSACTION_ERROR = 'billing/clearAllTransactionError';
export const CLEAR_STRIPE_TRANSACTION_REDIRECT_URL =
  'billing/clearStripeTransactionRedirectUrl';

export const addFundsToBank = (payload = {}) => ({
  type: ADD_FUNDS_TO_BANK,
  payload,
});

export const fetachAllPaymentTransactions = (payload = {}) => ({
  type: FETCH_ALL_PAYMENT_TRANSACTIONS,
  payload,
});

export const getAllInvoices = (payload = {}) => ({
  type: GET_ALL_INVOICES,
  payload,
});

export const downloadReport = (payload = {}) => ({
  type: DOWNLOAD_REPORT,
  payload,
});

export const downloadInvoice = (payload = {}) => ({
  type: DOWNLOAD_INVOICE,
  payload,
});

export const makeMonthlyPayment = (payload = {}) => ({
  type: MAKE_MONTHLY_PAYMENT,
  payload,
});

export const clearAllInvoicesError = (payload = {}) => ({
  type: CLEAR_ALL_INVOICES_ERROR,
  payload,
});

export const clearStripeRedirectUrl = (payload = {}) => ({
  type: CLEAR_STRIPE_REDIRECT_URL,
  payload,
});

export const clearAllTransactionError = (payload = {}) => ({
  type: CLEAR_ALL_TRANSACTION_ERROR,
  payload,
});

export const clearStripeTransactionRedirectUrl = (payload = {}) => ({
  type: CLEAR_STRIPE_TRANSACTION_REDIRECT_URL,
  payload,
});
